<template>
  <article>
    <navigation-slide v-if="arrMenuUserAssets" :arrMenu="arrMenuUserAssets" />
    <keep-alive>
      <router-view @current-scroll="value => currentScroll = value" :class="[getOS == 'ios' ? 'ios' : '']" />
    </keep-alive>
  </article>
</template>
<script>
import NavigationSlide from "../../../components/miniapp/global/NavigationSlide"
import { mapGetters, mapActions } from "vuex"
export default {
  components: {
    NavigationSlide
  },
  metaInfo: {
    title: process.env.VUE_APP_NAME
  },
  data() {
    return {
      shouldStick: true,
      arrMenu: [
        {
          route_name: "miniapp-market-fund",
          route_obj: { name: "miniapp-market-fund" },
          name: "FUNDS",
          route_replace: false,
          remember_router: true,
          route_scroll: 0
        },
        // {
        //   route_name: "miniapp-market-stock",
        //   route_obj: { name: "miniapp-market-stock" },
        //   name: "STOCKS",
        //   route_replace: false,
        //   remember_router: true,
        //   route_scroll: 0
        // },
        // {
        //   route_name: "miniapp-market-indices",
        //   route_obj: { name: "miniapp-market-indices" },
        //   name: "INDICES",
        //   route_replace: false,
        //   remember_router: true,
        //   route_scroll: 0
        // },
        {
          route_name: "miniapp-market-gold",
          route_obj: { name: "miniapp-market-gold" },
          name: "GOLD",
          route_replace: false,
          remember_router: true,
          route_scroll: 0
        },
        // {
        //   route_name: "miniapp-market-lotto",
        //   route_obj: { name: "miniapp-market-lotto" },
        //   name: "LOTTO",
        //   route_replace: false,
        //   remember_router: true,
        //   route_scroll: 0
        // },
        // {
        //   route_name: "miniapp-market-crypto",
        //   route_obj: { name: "miniapp-market-crypto" },
        //   name: "CRYPTO",
        //   route_replace: false,
        //   remember_router: true,
        //   route_scroll: 0
        // }
      ],
      currentScroll: 0
    }
  },
  watch: {
    $route: function(newRoute, oldRoute) {
      if (newRoute.name == "miniapp-market") {
        this.$router.push({
          name: this.getMarketActiveTab,
          query: this.$route.query
        })
      }
      this.arrMenu
        .filter(item => item.route_name === oldRoute.name)
        .map(item => (item.route_scroll = this.currentScroll))
    }
  },
  computed: {
    ...mapGetters("global", ["getMarketActiveTab"]),
    ...mapGetters("onboarding", ["getUserAssets"]),
    getOS() {
      return this.$liff.getOS()
    },
    arrMenuUserAssets() {
      if (this.getUserAssets && this.getUserAssets.length) {
        let arrData = []
        for (let asset of this.getUserAssets) {
          let menu = this.arrMenu.filter(item => item.name.includes(asset.toUpperCase()))
          menu.length ? arrData.push(menu[0]) : null
        }
        return arrData
      } else return this.arrMenu
    }
  },
  async created() {
    if (this.$route.name == "miniapp-market") {
      let routeName = await this.findAlreadyMenu(this.getUserAssets)
      if(!routeName) routeName = 'miniapp-market-fund' 
      this.$router.replace({
        name: routeName,
        query: this.$route.query
      })
      await this.saveMarketActiveTab(routeName)
    } else {
      this.$router.replace({
        name: this.$route.name,
        query: this.$route.query
      })
      await this.saveMarketActiveTab(this.$route.name)
    }
  },
  methods: {
    ...mapActions("global", ["saveMarketActiveTab"]),
    findAlreadyMenu(arrData) {
      for (let asset of arrData) {
        let alreadyAsset = this.arrMenu.filter(item => item.name.includes(asset.toUpperCase())).map(item=>item.route_name)[0]
        if (alreadyAsset) return alreadyAsset
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ios {
  @include manageiPhoneMedia;
}
</style>